import { render } from "./documentType.vue?vue&type=template&id=a49a1f7e&scoped=true"
import script from "./documentType.vue?vue&type=script&lang=js"
export * from "./documentType.vue?vue&type=script&lang=js"

import "./documentType.vue?vue&type=style&index=0&id=a49a1f7e&scoped=true&lang=css"
import "./documentType.vue?vue&type=style&index=1&id=a49a1f7e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a49a1f7e"]])

export default __exports__